<div *ngIf="loading" class="loader-overlay">
    <div>
      <img
        src="assets/gifs/logo-loading.gif"
        alt="Loading..."
        height="60.19px"
        width="107px"
      />
    </div>
  </div>
  